(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-logo"] && !Shopify.designMode) return;
  try {
    for (const logo of document.querySelectorAll('a.header-logo')) {
  logo.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const destination = new URL(logo.href);
    if (destination.origin === window.location.origin && destination.pathname === window.location.pathname) {
      event.preventDefault();
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
